module.exports = [{"name":"Toys, books, games, crayons, paper","quantity":1,"perishable":false,"shareable":true},{"name":"Formula","quantity":1,"perishable":true,"shareable":true},{"name":"Diapers","quantity":1,"perishable":false,"shareable":true}]


//////////////////
// WEBPACK FOOTER
// ./src/basekits/addons/kids.json
// module id = 293
// module chunks = 0